import { render, staticRenderFns } from "./DisplayValueComponent.vue?vue&type=template&id=5fb74c40&scoped=true&"
import script from "./DisplayValueComponent.vue?vue&type=script&lang=js&"
export * from "./DisplayValueComponent.vue?vue&type=script&lang=js&"
import style0 from "./DisplayValueComponent.vue?vue&type=style&index=0&id=5fb74c40&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb74c40",
  null
  
)

export default component.exports